export default __webpack_public_path__ + "static/media/initial-marker.ab2ff83d.svg";